import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

export const SelectAndChipsStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainWrapper: {
            marginBottom: theme.spacing(1),
        },
        labelIcon: {
            fontSize: 16,
            width: theme.spacing(2),
            height: theme.spacing(2),
            marginRight: theme.spacing(1),
            color: theme.palette.neutrals.dark,
        },
        labelTitle: {
            fontSize: 16,
            color: theme.palette.primary.main,
        },
        narratives: {
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1),
        },
        componentWrapper: {
            display: "flex",
            alignItems: "center",
        },
        selectWrapper: {
            display: "flex",
        },
        buttonPlus: {
            width: 50,
            height: 20,
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: 100,
            transition: "all .1s",
            "& .MuiSvgIcon-root": {
                fontSize: 8,
                color: theme.palette.primary.main,
            },
            "&:hover": {
                width: 52,
                boxShadow: `3px 2px 7px ${theme.palette.common.black}40`,
                "& .MuiSvgIcon-root": {
                    fontSize: 9,
                },
            },
        },
        selectField: {
            width: 330,
            height: 30,
            "& .MuiSelect-select": {
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
        optionsList: {
            borderRadius: theme.spacing(4),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
            maxHeight: 400,
            overflow: "hidden",
            "& .MuiList-root": {
                padding: theme.spacing(2),
                overflow: "auto",
                maxHeight: "inherit",
            },
        },
        menuItem: {
            padding: 0,
            "&:hover": {
                backgroundColor: "unset",
            },
        },
        menuItemInactive: {
            opacity: "50%",
        },
        chipBaseStyle: {
            width: "fit-content",
            cursor: "pointer",
            height: 20,
            my: 0,
            mr: 0.5,
            "& .MuiChip-deleteIcon": {
                fontSize: 14,
                color: theme.palette.neutrals.dark,
            },
        },
        selectedChipsWrapper: {
            display: "flex",
            flexWrap: "wrap",
        },
    })
);
